import {Kind, SearchType} from 'shared/constants';
import type {ForceSetting} from 'shared/value-editors/kp-value-editor-force-settings/types';

export const THREADS_VERSION = 'Verze modulu Threads: 1.0 IN-DEV';

export const OPEN_THREAD_POPOVER_EVENT = 'open-thread-popover-event';

export const THREAD_USER_SELECTOR_FORCE_SETTINGS: ForceSetting[] = [
    {
        type: 'user',
        options: {
            searchParams: {
                kind: Kind.KIND_USER,
                type: SearchType.TYPE_USER_SEARCH
            }
        }
    }
];